export const BREAKPOINTS = {
  mobile: '425px',
  tablet: '768px'
};
